/* eslint-disable import/max-dependencies */
// @flow
import {
  call,
  put,
  debounce,
  select,
} from "redux-saga/effects";
import type { Saga } from "redux-saga";
import type { Response } from "@fas/ui-framework/lib/services/request";
import { addNotification } from "@fas/ui-framework/lib/redux/actions/notifications";
import {
  getTablePage,
  getTablePageSize,
  getTableFilters,
} from "@fas/ui-framework/lib/redux/selectors/table";
import {
  setTableData,
  changeTableItemsTotalAmount,
} from "@fas/ui-framework/lib/redux/actions/table";
import { setLoading } from "@fas/ui-framework/lib/redux/actions/loading";
import type { Filters } from "@fas/ui-framework/lib/redux/reducers/table";
import {
  GET_TARGETINGS_LIST_SAGA,
  TARGETINGS_LIST_TABLE,
} from "../../helpers/constants";
import TargetingApi from "../../services/targetingsApi";
import type { Targeting } from "../../containers/TargetingsList";

export function* makeFetch(): Saga<void> {
  yield put(setLoading<typeof TARGETINGS_LIST_TABLE>(TARGETINGS_LIST_TABLE, true));

  const page: number = yield select(getTablePage, TARGETINGS_LIST_TABLE);
  const limit: number = yield select(getTablePageSize, TARGETINGS_LIST_TABLE);
  const filters: Filters = yield select(getTableFilters, TARGETINGS_LIST_TABLE);

  try {
    // $FlowFixMe @TODO resolve issue with axios params
    const { data: response }: Response<{
      data: Targeting[],
      totalCount: number
      // $FlowFixMe
    }> = yield call(
      TargetingApi.getTargetingsList,
      page,
      limit,
      filters
    );
    yield put(setTableData(TARGETINGS_LIST_TABLE, response.data));
    yield put(changeTableItemsTotalAmount(TARGETINGS_LIST_TABLE, response.totalCount));
  }
  catch (err) {
    yield put(addNotification({ message: err.errorMessage, severity: "error" }));
    // eslint-disable-next-line
    console.error(err);
  }
  finally {
    yield put(setLoading<typeof TARGETINGS_LIST_TABLE>(TARGETINGS_LIST_TABLE, false));
  }
}

export default function* watchFetchTargetingsListSaga(): Saga<void> {
  yield debounce(1000, GET_TARGETINGS_LIST_SAGA, (makeFetch: Function));
}
